import React from 'react';
const SvgMenu = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 32 32", focusable: false }, props),
    React.createElement("path", { d: "M0 3.238h32V7.81H0V3.238zm0 10.476h32v4.572H0v-4.572zM0 24.19h32v4.572H0V24.19z", fillRule: "evenodd" })));
export default SvgMenu;
//# sourceMappingURL=Menu.js.map